import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearchBar";
import { getControlField } from "../../../../Services/tooltipService";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import AddNewAssessmentPopup from "./AddNewAssessmentPopup";
import { getCustomer } from "../../../../Services/customerServices";
import ExcelUploader from "./ExcelUploader";
import { Dialog } from "primereact/dialog";
import { Toast } from 'primereact/toast';
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

const StakeholderAssessmentTable = lazy(() =>
  import("./StakeholderAssessmentTable")
);

const groupBy = (array, keyGetter) => {
  const map = new Map();
  array?.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};
const filterActiveOptions = (optionChoices) => {
  return optionChoices.filter((option) => option.status === "active");
};

const RdsFields = () => {
  const [customerId, setCustomerId] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [customer, setCustomer] = useState({});
  const [groupsDropdown, setGroupsDropdown] = useState({});
  const [fields, setFields] = useState([]);
  const [questionsArray, setQuestionsArray] = useState([]);
  const [referenceData, setReferenceData] = useState([]);
  const [controlPannel_RDSFields, setControlPannel_RDSFields] = useState([]);
  const [controlPannelRDSFieldsHeaders, setControlPannelRDSFieldsHeaders] =
    useState([]);
  const [projectModule, setProjectModule] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [dropdownHeaders, setDropdownHeaders] = useState([]);
  const [fieldHeader, setFieldHeader] = useState([]);
  const [newAssessmentPopupOpen, setNewAssessmentPopupOpen] = useState(false);
  const [uploadPopup, setUploadPopup] = useState(false);
  const [position, setPosition] = useState("center");
  const [visible, setVisible] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [deleted, setDeleted] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate()

  const toastRef = useRef();

  const controlFields = async (id) => {
    try {
      setLoading(true)
      const clientModuleDataResponse = await getControlField(id);
      const clientModuleData = clientModuleDataResponse?.data;
      if (clientModuleData) {
        const projectModules = clientModuleData.cust[0].modules.find(
          (module) => module.module_name === "Control Panel"
        ).tabs;
        setProjectModule(projectModules);

        const projectModules1 = clientModuleData.cust[0].modules.find(
          (module) => module.module_name === "Control Panel"
        );

        const cntlPannel_Fields = projectModules1.tabs.find(
          (tab) => tab.tab_name === "Fields"
        ).tables;

        const cntlPannelFieldsHeaders = cntlPannel_Fields.find(
          (table) => table.table_name === "Fields"
        ).headers;

        const cntlPannel_RDSFields = projectModules1.tabs.find(
          (tab) => tab.tab_name === "Stakeholder Assessment Fields"
        ).tables;
        setControlPannel_RDSFields(cntlPannel_RDSFields);
        const cntlPannelRDSFieldsHeaders = cntlPannel_RDSFields.find(
          (table) => table.table_name === "Stakeholder Assessment Fields"
        ).headers;
        setControlPannelRDSFieldsHeaders(cntlPannelRDSFieldsHeaders);
        const tableHeader = cntlPannelRDSFieldsHeaders.filter(
          (header) =>
            header.header_name === "Referred" || header.header_name === "Question"
        );
        const individualFields = cntlPannelRDSFieldsHeaders.filter(
          (header) =>
            header.header_name !== "Referred" && header.header_name !== "Question"
        );
        const dropdownHeader = cntlPannelRDSFieldsHeaders.filter(
          (header) =>
            header.header_name === "Dropdown Option" ||
            header.header_name === "Score" ||
            header.header_name === "Active/Inactive" ||
            header.header_name === "Options"
        );
        setFieldHeader(individualFields);
        setTableHeaders(tableHeader);
        setDropdownHeaders(dropdownHeader);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    var enduser = localStorage.getItem("enduser")
    if (enduser) {
      var currCustomer = JSON.parse(enduser);
      if (currCustomer && currCustomer.customer) {
        setCustomerId(currCustomer.customer);
        getRdsData(currCustomer.customer);
        controlFields(currCustomer.customer);
      } else {
        navigate("/login")
        localStorage.clear()
      }
    }
  }, []);



  useEffect(() => {
    var enduser = localStorage.getItem("enduser")
    if (enduser) {
      var currCustomer = JSON.parse(enduser);
      if (currCustomer && currCustomer.customer) {
        if (deleted) {
          getRdsData(currCustomer.customer);
          setDeleted(false)
        }
        if (!newAssessmentPopupOpen) {
          getRdsData(currCustomer.customer);
        }
        if (updated) {
          getRdsData(currCustomer.customer);
          setUpdated(false);
        }
      } else {
        navigate("/login")
        localStorage.clear()
      }
    }
  }, [deleted, newAssessmentPopupOpen, updated])

  const getRdsData = async (id) => {
    try {
      setDeleted(false)
      setUpdated(false)
      const customerData = await getCustomer(id);
      if (customerData) {
        // filtering dropdown options
        // Filtering data where option_names is "Group"
        const groupData = customerData?.data?.reference_data?.filter(
          (data) => data.option_names === "Group"
        );
        // Transforming labels into desired dropdown format
        const labels =
          groupData?.length > 0
            ? groupData[0].option_choice.map((option) => ({
              name: option.label,
              value: option.label,
            }))
            : [];
        setGroupsDropdown(labels);
        setCustomer(customerData.data);
        setFields(customerData.data.rds_data);
        setReferenceData(customerData.data.referenceData);
      }
      const groupedData = groupBy(customerData.data.rds_data, (ele) => ele.group);
      const groupedArray = Array.from(groupedData, ([key, value]) => ({
        key,
        value,
      }));
      setQuestionsArray(groupedArray);

      var group = [];
      if (customerData && customerData.data && customerData.data.referenceData) {
        group = customerData.data.referenceData.map((refData) =>
          filterActiveOptions(refData.option_choice)
        );
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleClearFilter = () => {
    setSearchQuery("");
  };
  const show = (position) => {
    setPosition(position);
    setVisible(true);
    setNewAssessmentPopupOpen(true);
  };
  // Open the Popup to add new Questions
  const handleAddAssessmentPopup = () => {
    setNewAssessmentPopupOpen(true);
  };
  // Close the add new Questions Popup
  const onClosePopup = () => {
    setNewAssessmentPopupOpen(false);
  };
  const onCloseUploadPopup = () => {
    setUploadPopup(false);
  };
  const childRef = useRef();

  const handleDeleteClick = () => {
    if (childRef.current) {
      childRef.current.enableDeletePopup();
    }
  };

  const handleSelectedItemsChange = (items) => {
    setSelectedItems(items); // Update the selected items state
  };
  const handleDeletedChange = (newState) => {
    setDeleted(newState); // Update the deleted state based on child's input
  };

  const handleUpdateChange = (newState) => {
    setUpdated(newState); // Update the deleted state based on child's input
  };

  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
  };

  return (
    <div className="group-table-component">
      <Toast ref={toastRef} />
      <Loader loading={loading} />
      <div className="header-design">
        <div>
          <p className="fs-16 fw-600 mar-b-3">{controlPannel_RDSFields[0]?.display_name}</p>
          <p className="group-table-text-section">
            Use this section to add and edit dropdown options for each question
          </p>
        </div>
        <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
        {/* <ButtonElement
          className="upload-button"
          type="button"
          icon="pi pi-question"
        /> */}
      </div>
      <div className="group-table-buttons">
        <div className="delete-button">
          {selectedItems.length > 0 &&
            <ButtonElement
              className="delete-button-icon"
              type="button"
              icon="pi pi-trash"
              onClick={() => handleDeleteClick()}
            />}
        </div>
        <div className="group-table-search">
          <ButtonElement
            className="delete-button-icon"
            type="button"
            icon="pi pi-upload"
            onClick={() => setUploadPopup(true)}
          />
          <HeaderSearchBar
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
            onClick={handleClearFilter}
          />
          <ButtonElement
            className="clear-filter-button"
            type="button"
            icon="pi pi-plus"
            label="New"
            onClick={() => show("right")}
          />
        </div>
      </div>

      {/* <div className="group-table-buttons">
        <div className="add-button">
          <ButtonElement
            className="upload-button"
            type="button"
            icon="pi pi-trash"
            onClick={handleDeleteClick}

          />
          <ButtonElement
            className="clear-filter-button"
            type="button"
            icon="pi pi-plus-circle"
            onClick={handleAddAssessmentPopup}
          />
        </div>
        <div className="group-table-search">
          <ButtonElement
            className="upload-button"
            type="button"
            icon="pi pi-upload"
            onClick={() => setUploadPopup(true)}
          />
          <ButtonElement
            className="clear-filter-button"
            icon="pi pi-filter-slash"
            onClick={handleClearFilter}
          />
          <HeaderSearchBar
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
          />
        </div>
      </div> */}
      <AddNewAssessmentPopup
        visible={newAssessmentPopupOpen}
        position={position}
        customer={customer}
        groupsDropdown={groupsDropdown}
        dropdownHeaders={dropdownHeaders}
        controlPannelRDSFieldsHeaders={controlPannelRDSFieldsHeaders}
        fieldHeader={fieldHeader}
        onClosePopup={onClosePopup}
      />
      <Suspense
        fallback={
          <div>
            <Loader loading={true} />
          </div>
        }
      >
        <StakeholderAssessmentTable
          tableHeaders={tableHeaders}
          groupsDropdown={groupsDropdown}
          questionsArray={questionsArray}
          fieldHeader={fieldHeader}
          dropdownHeaders={dropdownHeaders}
          searchQuery={searchQuery}
          customerData={customer}
          ref={childRef}
          toastRef={toastRef}
          onSelectedItemsChange={handleSelectedItemsChange}
          onDeletedChange={handleDeletedChange}
          onUpdateChange={handleUpdateChange}

        />
      </Suspense>

      <Dialog
        header={"Upload Formatted spreadsheet"}
        visible={uploadPopup}
        position="top"
        className="width-50vw"
        onHide={onCloseUploadPopup}
        draggable={false}
      >
        <ExcelUploader onCloseUploadPopup={onCloseUploadPopup} getData={getRdsData} />
      </Dialog>

      <Dialog id="videoModal" visible={showVideo}
        breakpoints={{
          '1200px': '80vw',    // Larger modal on bigger screens
          '1024px': '85vw',    // Slightly smaller for medium screens
          '769': '90vw',     // Responsive on tablets
          '641px': '95vw',     // Almost full-width on mobile
        }}
        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
      >
        <div className="video-overlay">
          <div className="video-container">
            <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_stakeholder_ass" />
          </div>
        </div>
      </Dialog>

    </div>
  );
};

export default RdsFields;
